import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { ModalProps } from "@material-ui/core/Modal";
import { PaperProps } from "@material-ui/core/Paper";
import { SlideProps } from "@material-ui/core/Slide";
import MuiDrawer, { DrawerClassKey as MuiDrawerClassKey } from "@material-ui/core/Drawer";
import { Theme } from "./styles";
import { TransitionProps, TransitionHandlerProps } from '@material-ui/core/transitions/transition';


export type DrawerClassKey = MuiDrawerClassKey;


export interface DrawerProps extends StandardProps<ModalProps & Partial<TransitionHandlerProps>, DrawerClassKey, 'open' | 'children'> {
    anchor?: 'left' | 'top' | 'right' | 'bottom';
    children?: React.ReactNode;
    elevation?: number;
    ModalProps?: Partial<ModalProps>;
    open?: boolean;
    PaperProps?: Partial<PaperProps>;
    SlideProps?: Partial<SlideProps>;
    theme?: Theme;
    transitionDuration?: TransitionProps['timeout'];
    variant?: 'permanent' | 'persistent' | 'temporary';
}

class Drawer extends React.PureComponent<DrawerProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDrawer {...props}>
            {this.props.children}
        </MuiDrawer>;
    }
}

export default Drawer;